import React from 'react';
import './Login.css';
// import AuthService from './AuthService';
import { authInstance } from './AuthService';
import Header from '../components/Header';
import mainLogo from '../images/Simulate-Login-Logo.png'

class Login extends React.Component {
    state = { username: "", password: "" }

    constructor() {
        super();
        // this.Auth = new AuthService();
        this.Auth = authInstance;
    }

    componentWillMount() {
        if (this.Auth.loggedIn())
            this.props.history.replace('/');
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    handleFormSubmit = (e) => {
        e.preventDefault();
        console.log(this.state);
        //call the login method from AuthService.js
        this.Auth.login(this.state.username, this.state.password)
            .then(res => {
                this.props.history.replace('/');
            })
            .catch(err => {
                // alert(err);
                alert("Incorrect Username or Password");
            })
    }

    render() {
        return (
            <div>
                {/* <Header /> */}
                <div className="vertical-align">
                    <div className="login-div">
                        <div className="login-form">
                            <div className="header">
                                <img src={mainLogo} alt="logo" />
                            </div>
                            <div className="login-flex-container-row">
                                <div className="login-flex-container-col">
                                      <form autoComplete="off">
                                        <div className="inputWithIcon">
                                        <i class="far fa-user fa-lg fa-fw icon-margin-user"></i>
                                            <input
                                                className="ip2"
                                                placeholder="Username"
                                                value={this.state.username}
                                                name="username"
                                                type="text"
                                                onChange={e => this.handleChange(e)}
                                            />
                                          
                                        </div>
                                        <div className="vertical-spacer"></div>
                                        <div className="inputWithIcon">
                                        <i class="fal fa-lock icon-margin-lock"></i>
                                            <input
                                                className="ip2"
                                                placeholder="Password"
                                                value={this.state.password}
                                                name="password"
                                                type="password"
                                                onChange={e => this.handleChange(e)}
                                            />
                                           
                                        </div>
                                        <div className="vertical-spacer"></div>
                                        <button onClick={e => this.handleFormSubmit(e)} className="login-button">LOGIN</button>
                                    </form>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </div>
        );
    }


}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js